import { useMemo, useRef } from "react";

import { useStableRest } from "../../utils/use-stable-rest";
import styles from "./kanban.module.scss";
import type { KanbanBoardAttributes, KanbanViewModel, UseKanbanBoardOptions } from "./types-kanban";

/** ViewModel do `Kanban.Board`: dispositivo, sangria, a área que rola e o resto das props da raiz; sem JSX. */
export function useKanban({
  device = "desktop",
  bleed = false,
  testId,
  className,
  style,
  ...props
}: UseKanbanBoardOptions & KanbanBoardAttributes): KanbanViewModel {
  const rest = useStableRest(props);
  const scrollerRef = useRef<HTMLDivElement | null>(null);
  const context = useMemo(() => ({ device }), [device]);

  return {
    context,
    device,
    bleedClassName: bleed ? styles.bleed : undefined,
    scrollerRef,
    testId,
    scrollBarTestId: testId ? `${testId}-scrollbar` : undefined,
    className,
    style,
    rest,
  };
}
